module.exports = __webpack_public_path__ + "img/connections_liveR.f1458e88.png";